import { Text, VStack } from "@chakra-ui/react";
import { RGrid } from "@raiden/library/components/RGrid";
import { useIntl } from "react-intl";
import { CONTRACTS_LIST } from "../../../constants/contracts";
import { Icon } from "../../Icon";

export function ContractsPicker({ value, onChange }) {
  const intl = useIntl();

  return (
    <RGrid minCellWidth="150px">
      {CONTRACTS_LIST.map((contract) => {
        const isChecked = value.includes(contract.value);

        return (
          <VStack
            as="button"
            type="button"
            onClick={(e) => {
              if (isChecked) {
                onChange(value.filter((v) => v !== contract.value));
              } else {
                onChange([...value, contract.value]);
              }
            }}
            py="1rem"
            px="1.5rem"
            borderBottomWidth="2px"
            borderBottomColor={isChecked ? "brandPrimary.300" : "transparent"}
            backgroundColor={isChecked ? "#fff" : "transparent"}
            _hover={{
              backgroundColor: "#fff",
            }}
            key={contract.value}>
            <Icon icon={contract.icon} size="3rem" color="#9BA5D6" />

            <Text as="span">{intl.formatMessage(contract.name)}</Text>
          </VStack>
        );
      })}
    </RGrid>
  );
}
